import { render, staticRenderFns } from "./learningmaterials.vue?vue&type=template&id=003f9f20&scoped=true"
import script from "./learningmaterials.vue?vue&type=script&lang=js"
export * from "./learningmaterials.vue?vue&type=script&lang=js"
import style0 from "./learningmaterials.vue?vue&type=style&index=0&id=003f9f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f9f20",
  null
  
)

export default component.exports